const DEPLOY_GRAPHQL_API =
  process.env.REACT_APP_DEPLOY_GRAPHQL_API ?? window.location.origin

export const config = {
  DEPLOY_GRAPHQL_API: `${DEPLOY_GRAPHQL_API}/api/graphql`,
  GORILLA_GRAPHQL_API: 'https://api.wandb.ai/graphql',
  LOGIN_REDIRECT: 'https://api.wandb.ai/oidc/login',
  LOGOUT_REDIRECT: 'https://wandb.ai/logout'
}
